import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class BookingCategoryStore {

    // Properties

    // Modal Create/Update Properties

    @observable showBookingCategoryModal = false;
    @observable bookingCategoryTitle = '';

    @observable tabNameActiveKey = '1';
    @observable tabDescriptionActiveKey = '1';

    @observable bookingCategories = [];
    @observable id = 0;

    @observable name = '';
    @observable nameEnglish = '';
    @observable nameChinese = '';
    @observable nameChineseTraditional = '';
    @observable nameThai = '';
    @observable nameJapanese = '';
    @observable nameVietnamese = '';

    @observable description = '';
    @observable descriptionEnglish = '';
    @observable descriptionChinese = '';
    @observable descriptionChineseTraditional = '';
    @observable descriptionThai = '';
    @observable descriptionJapanese = '';
    @observable descriptionVietnamese = '';

    @observable capacity = 1;
    @observable isAvailable = true;
    @observable maxHourPerDay = 0;
    @observable sortOrder = 0;

    @observable itemTextButton = 'Create';

    // Helper Properties

    @observable bookingCategoryListLoading = false;
    @observable bookingCategoryModalLoading = false;

    // Initialization

    @action initBookingCategory() {
        this.bookingCategoryListLoading = true;

        ApiCaller.BookingCategories.getAll().then(responseFirst => {
            if (responseFirst && responseFirst.isSuccess) {
                var model = responseFirst.model;
                this.bookingCategories = model;
                this.bookingCategoryListLoading = false;
            } else {
                this.bookingCategories = [];
                this.bookingCategoryListLoading = false;
            }
        });
    }

    @action initCreateBookingCategory() {
        this.bookingCategoryTitle = 'Create Booking Category';

        this.id = 0;
        this.name = '';
        this.nameEnglish = '';
        this.nameChinese = '';
        this.nameChineseTraditional = '';
        this.nameThai = '';
        this.nameJapanese = '';
        this.nameVietnamese = '';
        this.description = '';
        this.descriptionEnglish = '';
        this.descriptionChinese = '';
        this.descriptionChineseTraditional = '';
        this.descriptionThai = '';
        this.descriptionJapanese = '';
        this.descriptionVietnamese = '';
        this.capacity = 1;
        this.isAvailable = true;
        this.maxHourPerDay = 0;
        this.sortOrder = 0;
        this.itemTextButton = 'Create';
        this.showBookingCategoryModal = true;
    }

    @action initUpdateBookingCategory(id) {
        this.bookingCategoryModalLoading = true;
        this.bookingCategoryTitle = 'Update Booking Category';
        this.itemTextButton = 'Save';
        this.showBookingCategoryModal = true;

        ApiCaller.BookingCategories.getById(id).then(response => {
            if (response && response.isSuccess) {
                var model = response.model;
                this.id = model.id;
                this.name = model.name;
                this.nameEnglish = model.nameLang.english;
                this.nameChinese = model.nameLang.chinese;
                this.nameChineseTraditional = model.nameLang.chineseTraditional;
                this.nameThai = model.nameLang.thai;
                this.nameJapanese = model.nameLang.japanese;
                this.nameVietnamese = model.nameLang.vietnamese;
                this.description = model.description;
                this.descriptionEnglish = model.descriptionLang.english;
                this.descriptionChinese = model.descriptionLang.chinese;
                this.descriptionChineseTraditional = model.descriptionLang.chineseTraditional;
                this.descriptionThai = model.descriptionLang.thai;
                this.descriptionJapanese = model.descriptionLang.japanese;
                this.descriptionVietnamese = model.descriptionLang.vietnamese;
                this.capacity = model.capacity;
                this.isAvailable = model.isAvailable;
                this.maxHourPerDay = model.maxHourPerDay;
                this.sortOrder = model.sortOrder;
                this.itemTextButton = 'Save';
                this.bookingCategoryModalLoading = false;
            }
        });
    }

    // Transaction

    @action createBookingCategory() {
        this.bookingCategoryModalLoading = true;

        const request = {
            'name': this.name,
            'nameLang': {
                'english': this.nameEnglish,
                'chinese': this.nameChinese,
                'chineseTraditional': this.nameChineseTraditional,
                'thai': this.nameThai,
                'japanese': this.nameJapanese,
                'vietnamese': this.nameVietnamese
            },
            'description': this.description,
            'descriptionLang': {
                'english': this.descriptionEnglish,
                'chinese': this.descriptionChinese,
                'chineseTraditional': this.descriptionChineseTraditional,
                'thai': this.descriptionThai,
                'japanese': this.descriptionJapanese,
                'vietnamese': this.descriptionVietnamese
            },
            'capacity': this.capacity,
            'isAvailable': this.isAvailable,
            'maxHourPerDay': this.maxHourPerDay,
            'sortOrder': this.sortOrder
        };

        return ApiCaller.BookingCategories.create(request).then((response) => {
            this.bookingCategoryModalLoading = false;

            if (response && response.isSuccess) {
                this.initBookingCategory();
                this.showBookingCategoryModal = false;
            }

            return response;
        });
    }

    @action updateBookingCategory() {
        this.bookingCategoryModalLoading = true;

        const request = {
            'id': this.id,
            'name': this.name,
            'nameLang': {
                'english': this.nameEnglish,
                'chinese': this.nameChinese,
                'chineseTraditional': this.nameChineseTraditional,
                'thai': this.nameThai,
                'japanese': this.nameJapanese,
                'vietnamese': this.nameVietnamese
            },
            'description': this.description,
            'descriptionLang': {
                'english': this.descriptionEnglish,
                'chinese': this.descriptionChinese,
                'chineseTraditional': this.descriptionChineseTraditional,
                'thai': this.descriptionThai,
                'japanese': this.descriptionJapanese,
                'vietnamese': this.descriptionVietnamese
            },
            'capacity': this.capacity,
            'isAvailable': this.isAvailable,
            'maxHourPerDay': this.maxHourPerDay,
            'sortOrder': this.sortOrder
        };

        return ApiCaller.BookingCategories.update(request).then((response) => {
            this.bookingCategoryModalLoading = false;

            if (response && response.isSuccess) {
                this.initBookingCategory();
                this.showBookingCategoryModal = false;
            }

            return response;
        });
    }

    @action deleteUpdateBookingCategory(id) {
        this.bookingCategoryListLoading = true;

        return ApiCaller.BookingCategories.delete(id).then((response) => {
            this.bookingCategoryListLoading = false;
            if (response && response.isSuccess) {
                this.initBookingCategory();
            }
            return response;
        });
    }

    // SET Properties

    @action setShowBookingCategoryModal(value) {
        this.showBookingCategoryModal = value;
        if (!value) {
            this.tabNameActiveKey = '1';
            this.tabDescriptionActiveKey = '1';
        }
    }

    @action setNameEnglish(value) {
        this.nameEnglish = value;
        this.name = this.nameEnglish;
    }

    @action setNameChinese(value) {
        this.nameChinese = value;
    }

    @action setNameChineseTraditional(value) {
        this.nameChineseTraditional = value;
    }

    @action setNameThai(value) {
        this.nameThai = value;
    }

    @action setNameJapanese(value) {
        this.nameJapanese = value;
    }

    @action setNameVietnamese(value) {
        this.nameVietnamese = value;
    }

    @action setDescriptionEnglish(value) {
        this.descriptionEnglish = value;
        this.description = this.descriptionEnglish;
    }

    @action setDescriptionChinese(value) {
        this.descriptionChinese = value;
    }

    @action setDescriptionChineseTraditional(value) {
        this.descriptionChineseTraditional = value;
    }

    @action setDescriptionThai(value) {
        this.descriptionThai = value;
    }

    @action setDescriptionJapanese(value) {
        this.descriptionJapanese = value;
    }

    @action setDescriptionVietnamese(value) {
        this.descriptionVietnamese = value;
    }

    @action setCapacity(value) {
        this.capacity = value;
    }

    @action setIsAvailable(value) {
        this.isAvailable = value;
    }

    @action setMaxHourPerDay(value) {
        this.maxHourPerDay = value;
    }

    @action setSortOrder(value) {
        this.sortOrder = value;
    }

    @action setTabNameActiveKey(value) {
        this.tabNameActiveKey = value;
    }

    @action setTabDescriptionActiveKey(value) {
        this.tabDescriptionActiveKey = value;
    }
}

export default new BookingCategoryStore()
